import {z as r} from 'zod';

import {postAndDeserialize} from '../../util/api-adapter';

export type DirectorReportPeriodType = 'weekly' | 'monthly';

export type DirectorReportSendRequestType = {
    email: string;
    reportType: DirectorReportPeriodType;
};

const directorReportSendResponseSchema = r.object({
    status: r.string(),
    email: r.string(),
});

export type DirectorReportSendResponseType = r.infer<typeof directorReportSendResponseSchema>;

export function sendDirectorReport(payload: DirectorReportSendRequestType): Promise<DirectorReportSendResponseType> {
    return postAndDeserialize<DirectorReportSendResponseType>(
        '/v1/user/director_report/send/',
        directorReportSendResponseSchema,
        payload
    );
}
